import { tv } from 'tailwind-variants'

export const createVariants = tv
